import { Link } from "react-router-dom";
import { useSettings } from "@/context/AppContext";
import { fileUrl } from "@/lib/api";
import { logoSrc } from "@/lib/images";
import { cn } from "@/lib/utils";

export const Logo = ({ size = 44, withText = true, light = false, compact = false, className }) => {
  const s = useSettings();
  return (
    <Link to="/" data-testid="brand-logo" className={cn("inline-flex items-center gap-2.5", className)}>
      <img src={fileUrl(logoSrc(s))} alt="ZEEVA PRO | زيفا برو — كل خدمة ... أقرب" width={size} height={size} className="shrink-0 object-contain" style={{ width: size, height: size }} />
      {withText && (
        <span className={cn("whitespace-nowrap leading-tight", compact && "hidden sm:block")}>
          <span className={cn("block text-lg font-extrabold tracking-tight", light ? "text-white" : "text-[#0B192C]")}>ZEEVA PRO</span>
          <span className="hidden text-[11px] font-semibold z-gradient-text sm:block">زِيفا برو · كل خدمة ... أقرب</span>
        </span>
      )}
    </Link>
  );
};
